import { ReactKeycloakProvider, useKeycloak } from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import { WebStorageStateStore } from "oidc-client-ts";
import React from "react";
import { AuthProvider } from "react-oidc-context";
const oidcConfig = {
  authority: process.env.REACT_APP_KEYCLOAK_AUTHORITY,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  client_secret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET,
  grant_type: "password",
  // post_logout_redirect_uri:
  //   window.location.href || process.env.REACT_APP_KEYCLOAK_REDIRECT_URI,
  // redirect_uri:
  // window.location.href || process.env.REACT_APP_KEYCLOAK_REDIRECT_URI,
  post_logout_redirect_uri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URI,
  redirect_uri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URI,
  scope: "openid profile",
  // stateStore: new WebStorageStateStore({ store: window.localStorage }),
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: (user) => {
    // if (!user) return;
    window.history.replaceState({}, document.title, window.location.pathname);
    window.location = user.state || "/";
  },
};
const keycloak = new Keycloak({
  checkLoginIframe: false,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  clientSecret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET,
  enableLogging: true,
  flow: "standart",
  grantType: "password",
  onLoad: "check-sso",
  realm: "5systems",
  scope: "profile",
  url: "https://login.5systems.ru/",
});
export const OidcContext = React.createContext();

function OidcProvider({ children }) {
  return (
    <ReactKeycloakProvider authClient={keycloak}>
      <OidcContext.Provider value={""}>
        <AuthProvider {...oidcConfig}>{children}</AuthProvider>
      </OidcContext.Provider>
    </ReactKeycloakProvider>
  );
}

export { OidcProvider };
